import { Node } from "#/decision_tree_viewer/models/node";

export class MissingVisitTypeNode extends Node {
  get defaults() {
    return {
      id: "missing-visit-type",
      name: "MissingVisitTypeNode",
    };
  }

  get message() {
    return "|PROVIDER-NAME| does not currently have any |SELECTED-VISIT-TYPE:appropriate| appointments available for |PATIENT-TYPE| patients.";
  }
}
